import React, { useEffect, useRef, useState } from 'react';
import { HiArrowTrendingUp } from 'react-icons/hi2';
import { useScrollReveal } from '../utils/useScrollReveal';
import './BeforeAfter.css';

const METRICS = [
  { label: 'Conversion', before: '5–10%', after: '67.8%', change: '+578%', barFrom: 8, barTo: 68 },
  { label: 'Downloads', before: '~50/day', after: '1,770', change: 'Spike', barFrom: 5, barTo: 90 },
  { label: 'Page Views', before: '~200/day', after: '2,970', change: '+1,385%', barFrom: 8, barTo: 85 },
  { label: 'Impressions', before: '~500/day', after: '4,950', change: '+890%', barFrom: 12, barTo: 80 },
];

export default function BeforeAfter() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);
  const [textRef, textVisible] = useScrollReveal();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="before-after section" id="results" ref={sectionRef}>
      <div className="container">
        <div className="before-after__layout">
          {/* Left: Text */}
          <div ref={textRef} className={`before-after__text reveal-left ${textVisible ? 'is-revealed' : ''}`}>
            <span className="section-label">Real Results</span>
            <h2 className="section-title">Same App.<br />Better Storefront.</h2>
            <p className="before-after__desc">
              Real App Store Connect numbers — zero code changes.
              Just professional screenshots and optimized metadata.
            </p>

            <div className="before-after__highlights">
              <div className="before-after__highlight">
                <HiArrowTrendingUp />
                <div>
                  <strong>67.8%</strong>
                  <span>conversion rate</span>
                </div>
              </div>
              <div className="before-after__highlight">
                <HiArrowTrendingUp />
                <div>
                  <strong>1,770</strong>
                  <span>downloads in one spike</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Animated illustration */}
          <div className={`before-after__illustration reveal-right ${visible ? 'is-visible is-revealed' : ''}`}>
            {METRICS.map((m, i) => (
              <div className="metric-row" key={i} style={{ '--delay': `${i * 0.15}s` }}>
                <div className="metric-row__head">
                  <span className="metric-row__label">{m.label}</span>
                  <span className="metric-row__change">
                    <HiArrowTrendingUp />
                    {m.change}
                  </span>
                </div>
                <div className="metric-row__bars">
                  <div className="metric-row__bar metric-row__bar--before">
                    <div
                      className="metric-row__bar-fill metric-row__bar-fill--before"
                      style={{ width: visible ? `${m.barFrom}%` : '0%' }}
                    ></div>
                    <span className="metric-row__bar-label">{m.before}</span>
                  </div>
                  <div className="metric-row__bar metric-row__bar--after">
                    <div
                      className="metric-row__bar-fill metric-row__bar-fill--after"
                      style={{ width: visible ? `${m.barTo}%` : '0%' }}
                    ></div>
                    <span className="metric-row__bar-label">{m.after}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
